import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { IMAGES } from "../../lib/data";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#030303] px-5 pb-10 pt-24 sm:pt-28 md:px-12 md:pb-16 md:pt-32"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid items-center gap-8 md:grid-cols-[0.95fr_1.05fr] md:gap-10 lg:gap-16">
          {/* Copy */}
          <div className="relative z-20 order-1">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
            >
              <div className="mb-4 flex items-center gap-2 font-body text-[9px] tracking-[0.28em] text-white/45 uppercase md:mb-6 md:text-[10px]">
                <span className="h-1.5 w-1.5 rounded-full bg-[#e63946] shadow-[0_0_12px_rgba(230,57,70,0.9)]" />
                Creative Video / SMM
              </div>

              <h1 className="font-display text-[21vw] uppercase leading-[0.78] tracking-tight text-white sm:text-8xl md:text-[7.2rem] lg:text-[8.8rem]">
                Yernar
                <span className="block text-[#e63946]">Assanbekov</span>
              </h1>

              <p className="mt-5 max-w-xl font-body text-[9px] tracking-[0.16em] text-white/60 uppercase sm:text-[11px] md:mt-6 md:text-xs md:tracking-[0.28em]">
                Видеограф <span className="mx-1 text-[#e63946]">•</span> Мобилограф <span className="mx-1 text-[#e63946]">•</span> SMM-специалист
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="mt-7 max-w-md md:mt-10"
            >
              <p className="font-body text-sm leading-relaxed text-white/68 sm:text-base md:text-lg">
                Создаю видео, которые помогают брендам выделяться,
                привлекать внимание и увеличивать продажи.
              </p>

              <a
                href="#portfolio"
                data-cursor="link"
                data-testid="hero-cta-works"
                className="group mt-7 inline-flex items-center gap-3 rounded-full border border-[#e63946] px-5 py-3.5 font-body text-[10px] tracking-[0.2em] text-white uppercase transition-all duration-300 hover:bg-[#e63946] hover:shadow-[0_0_35px_rgba(230,57,70,0.28)] sm:px-7 md:mt-8 md:text-[11px]"
              >
                Смотреть работы
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden />
              </a>
            </motion.div>
          </div>

          {/* Portrait — independent column, never behind the copy */}
          <motion.div
            initial={{ opacity: 0, x: 30, scale: 0.97 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            transition={{ duration: 1, delay: 0.15, ease: [0.65, 0, 0.35, 1] }}
            className="relative order-2 md:self-stretch"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-neutral-900 md:h-full md:min-h-[610px] md:aspect-auto md:rounded-[2rem]">
              <img
                src={IMAGES.heroBg}
                alt="Yernar Assanbekov — видеограф"
                className="absolute inset-0 h-full w-full object-cover object-center"
              />

              {/* Cinematic left-to-right fade */}
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#030303]/80 via-[#030303]/15 to-transparent md:from-[#030303]/75" />

              {/* Bottom vignette */}
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-black/10" />

              <a
                href="#contact"
                data-cursor="link"
                data-testid="hero-badge-contact"
                className="absolute bottom-5 left-5 flex items-center gap-3 rounded-full border border-white/15 bg-black/35 px-4 py-2.5 backdrop-blur-md transition-colors duration-300 hover:border-[#e63946]/60 hover:bg-black/50 md:bottom-7 md:left-7"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#e63946] text-white shadow-[0_0_20px_rgba(230,57,70,0.35)]">
                  <Play className="ml-0.5 h-3 w-3 fill-current" aria-hidden />
                </span>
                <span className="font-body text-[9px] tracking-[0.2em] text-white uppercase">
                  Обсудить проект
                </span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
